import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { CerRealtimeServerService } from './cer-realtime-server.service';
import { ApplicationStateVm, ChatDto, NotificationMessageDto, ProgressDto, UserStatusVm } from 'src/app/api';
import { CerAppChatService } from 'src/cer-app/cer-app-chat/cer-app-chat.service';
import { CerAppNotificationService } from 'src/cer-app/cer-app-notifications/cer-app-notification.service';

import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

@Injectable({
  providedIn: 'root'
})
export class CerAppRealtimeService implements OnDestroy {

  private subscriptionManager$: Subscription = new Subscription();

  constructor(
    private serverService: CerRealtimeServerService,
    private sessionService: CerSessionService,
    private chatService: CerAppChatService,
    private notificationsService: CerAppNotificationService) {

    this.subscriptionManager$.add(
      sessionService.isAuthenticated$.subscribe(isAuthenticated => this.onAuthenticated(isAuthenticated))
    );

    this.subscriptionManager$.add(
      serverService.isStarted$.subscribe(started => { if (started) this.onStart(); })
    );
    this.subscriptionManager$.add(
      serverService.onStopped$.subscribe(error => { this.onStopped(error); })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }

  private onAuthenticated(isAuthenticated: boolean): void {
    if (isAuthenticated) {
      var accessToken : string = null;
      this.start(accessToken);
    }
    else {
      this.stop();
    }
  }

  private restart() {
    var accessToken : string = null;
    if (true) {
      this.start(accessToken);
    }
  }

  private start(loginToken: string) {
    this.serverService.start(loginToken);
  }

  private stop() {
    this.serverService.stop();
  }


  private onStart() {
    this.serverService.on('BroadcastUserStatus', (userStatus: UserStatusVm) => this.sessionService.onUserStatusVm(userStatus));
    this.serverService.on('BroadcastApplicationState', (state: ApplicationStateVm) => this.sessionService.onApplicationState(state));
    this.serverService.on('BroadcastChatPosted', (chats: ChatDto[]) => this.chatService.chatsSet(chats));
    this.serverService.on('UserNotifications', (userNotifications: NotificationMessageDto[]) => this.notificationsService.userNotificationsSet(userNotifications));
    this.serverService.on('SendProgress', (progress: ProgressDto) => this.sessionService.onProgress(progress));
  }

  private onStopped(error: Error) {
    var that = this;
    setTimeout(function() { that.restart(); }, 5000);
  }

}
